import {h} from 'preact';
import Icon from '@components/common/Icon';
import {classList} from '../index';

const Index = ( {children} ) => (
    <div data-testid="cart-empty" className={classList.cartEmpty}>
        {children}
        <Icon.ui name="shopping-cart" className="text-xl"/>
        <h2 className="text-lg mb-4">Your cart is empty</h2>
        <p>
            <a href="/products/categories" className="link1">Browse&nbsp;products by categories</a>
        </p>
    </div>
);

export default Index;
